import React from 'react'
import { createContext, useState } from "react";




const ApiResponseContext = createContext([]);
const ApiResponseContextProvider = ({children}) => {
    const [data,setData] = useState([])


  return (
   <ApiResponseContext.Provider 
   value={{ data,setData }}
   >
    {children}
   </ApiResponseContext.Provider>
  )
}

export  {ApiResponseContextProvider ,ApiResponseContext}